const PLAN_LABELS = { starter: 'Starter', pro: 'Pro' };

/**
 * Map the live billing status (Stripe — the Unify source of truth) into the
 * plain plan label + status string the AI assistant is given as context.
 *
 * The assistant must NEVER be fed the legacy `shop.plan` field: on migrated
 * shops it can still read "lite" (an old NearSt plan name) or be stale, which
 * is exactly what made Ask AI tell Pro customers they were on "Lite" (NEA-5906).
 * Unify only has Starter and Pro plans, so we derive both off `useBillingStatus()`.
 *
 * Returns `{ plan: null, planStatus: null }` when billing hasn't loaded yet so
 * the assistant simply omits the plan rather than guessing.
 */
export function describeAssistantPlan(billing) {
	if (!billing) return { plan: null, planStatus: null };

	const plan = PLAN_LABELS[billing.plan] ?? null;

	let planStatus = null;
	if (billing.expired) {
		planStatus = 'expired (subscription needs reactivating)';
	} else if (billing.isTrialing || billing.status === 'trialing') {
		planStatus = typeof billing.daysLeft === 'number' ? `free trial (${billing.daysLeft} days left)` : 'free trial';
	} else if (billing.status === 'active') {
		planStatus = 'active';
	} else if (billing.status === 'no_subscription') {
		planStatus = 'no active subscription';
	} else if (billing.status) {
		planStatus = billing.status;
	}

	return { plan, planStatus };
}
